import { axiosClassic } from '../api'

export interface RequestItem {
	id: number
	createdDate: string
	datePlan: string
	description: string
	districtName: string
	executor: string
	finalDate: string | null
	houseNum: string
	problemName: string
	reasonName: string
	streetName: string
}

export interface RequestsResponse {
	data: RequestItem[]
	total: number
	limit: number
	offset: number
	hasMore: boolean
}

export interface RequestsParams {
	offset?: number
	limit?: number
	streetName?: string
}

export interface RepairWorkByHouse {
	uniqueId: number
	id: number
	affectedStreets: string
	houseId: number | null
	streetId: number
	streetName: string | null
	houseNum: string
	eventName: string | null
	eventNumber: number
	eventText: string
	executor: string
	problemId: number | null
	problem: string | null
	reason: string | null
	dateBegSort: string
	dateBeg: string | null
	datePlan: string | null
	isEmergency: string | null
}

export interface RepairWorkByHouseResponse {
	data: RepairWorkByHouse[]
	total: number
	limit: number
	offset: number
	hasMore: boolean
}

export interface MapAppealsFilter {
	status?: string
	problemId?: number
	dateFrom?: string
	dateTo?: string
}

export interface MapAppeal {
	id: number
	requestNum: number
	status: string
	statusId: number
	districtName: string
	streetName: string
	houseNum: string
	executor: string
	description: string
	createdDate: string
	datePlan: string | null
	finalDate: string | null
	problemId: number
	problemName: string
	reasonId: number
	reasonName: string
	lat: number
	lon: number
}

export interface MapPoint {
  lat: number
  lon: number
  count: number
  hasInWork: number
  houseId: number  
}

export interface RequestsSearchParams {
	streetName?: string
	houseNum?: string
	requestNum?: number
}

export interface RequestCount {
	inWork: number
	processed: number
}

export interface RequestProblem {
	id: number
	parentId: number | null
	nameUa: string
	clientGroup: number | null
}

interface PaginatedResponse<T> {
  data: T[]
  total: number
  hasMore: boolean
}

class RequestsService {
	private BASE_URL = '/requests'

	async findAll(params: {
		offset: number
		streetId?: number
	}): Promise<RepairWorkByHouseResponse> {
		const response = await axiosClassic.get<RepairWorkByHouseResponse>(
			this.BASE_URL,
			{
				params: {
					offset: params.offset,
					streetId: params.streetId,
				},
			},
		)
		return response.data
	}



  async getMapRequests(problemId?: number, period?: string): Promise<MapPoint[]> {
    const response = await axiosClassic.get<MapPoint[]>(`${this.BASE_URL}/map`, {
      params: { problemId, period }
    })
    return response.data
  }

  
	async getRequestsByHouseId(
	houseId: number,
	problemId?: number,
	period?: string,
	limit: number = 5,
	offset: number = 0,
	): Promise<PaginatedResponse<MapAppeal>> {
	const response = await axiosClassic.get<PaginatedResponse<MapAppeal>>(
		`${this.BASE_URL}/map/by-address`,
		{ params: { houseId, problemId, period, limit, offset } },
	)
	return response.data
	}

	async getRequestsCounters(period?: string): Promise<RequestCount> {
	const response = await axiosClassic.get<RequestCount>(
		`${this.BASE_URL}/counters`,
		{ params: { period } },
	)
	return response.data
	}

	async getRequestByNumber(requestNum: number): Promise<MapAppeal | null> {
		const response = await axiosClassic.get<MapAppeal>(
			`${this.BASE_URL}/map/by-number`,
			{ params: { requestNum } },
		)
		return response.data
	}

	async searchRequests(params: RequestsSearchParams): Promise<MapAppeal[]> {
		const response = await axiosClassic.get<MapAppeal[]>(
			`${this.BASE_URL}/map/search`,
			{ params },
		)
		return response.data
	}

	async getProblems(): Promise<RequestProblem[]> {
		const response = await axiosClassic.get<RequestProblem[]>(
			`${this.BASE_URL}/problems`,
		)
		return response.data
	}

}

export const requestsService = new RequestsService()